import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  IconButton,
  Typography,
  TextField,
  MenuItem,
} from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useMediaQuery } from "@mui/system";

const CustomPagination = ({
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const totalPages = Math.ceil(count / rowsPerPage);

  const handlePrevious = () => {
    if (page > 0) onPageChange(null, page - 1);
  };

  const handleNext = () => {
    if (page < totalPages - 1) onPageChange(null, page + 1);
  };

  const handleRowsPerPageChange = (event) => {
    onRowsPerPageChange(event);
  };

  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mt={3}
      p={2}
      sx={
        {
          // background: "#fdfdfd",
          // borderRadius: "8px",
          // boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        }
      }
    >
      {/* Rows per page */}
      <Box display="flex" alignItems="center" gap={1}>
        <Typography
          variant="body2"
          sx={{ fontWeight: 400, fontSize: isMobile ? "10px" : "14px" }}
        >
          Rows per page:
        </Typography>
        <TextField
          select
          value={rowsPerPage}
          onChange={handleRowsPerPageChange}
          size="small"
          sx={{
            fontSize: isMobile ? "10px" : "14px",
            minWidth: "50px",
            "& .MuiInputBase-root": {
              // background: "#fff",
              borderRadius: "4px",
            },
          }}
        >
          {[5, 10, 15].map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      {/* Pagination Controls */}
      <Box display="flex" alignItems="center" gap={1}>
        <IconButton
          onClick={handlePrevious}
          disabled={page === 0}
          sx={{
            fontSize: isMobile ? "10px" : "14px",
            color: page === 0 ? "#ccc" : "#453c72",
            backgroundColor: page === 0 ? "transparent" : "#d6dfff",
            "&:hover": {
              backgroundColor: "#d6dfff",
            },
          }}
        >
          <ArrowBack />
        </IconButton>
        <Typography
          variant="body2"
          sx={{ fontWeight: 400, fontSize: isMobile ? "10px" : "14px" }}
        >
          Page {page + 1} of {totalPages}
        </Typography>
        <IconButton
          onClick={handleNext}
          disabled={page === totalPages - 1}
          sx={{
            fontSize: isMobile ? "10px" : "14px",
            color: page === totalPages - 1 ? "#ccc" : "#453c72",
            backgroundColor:
              page === totalPages - 1 ? "transparent" : "#d6dfff",
            "&:hover": {
              backgroundColor: "#d6dfff",
            },
          }}
        >
          <ArrowForward />
        </IconButton>
      </Box>
    </Box>
  );
};

CustomPagination.propTypes = {
  count: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
};

CustomPagination.defaultProps = {
  rowsPerPage: 10,
  page: 0,
};

export default CustomPagination;
